if (!customElements.get('sticky-cta-bar')) {
  customElements.define(
    'sticky-cta-bar',
    class StickyCtaBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.mainSectionId;
        this.mainButton = Array.from(document.querySelectorAll('.product-form__buttons')).find(
          (el) => !this.contains(el)
        );
        this.footer = document.querySelector('.footer');
        this.pastTrigger = false;
        this.nearFooter = false;

        if (this.mainButton) {
          this.triggerObserver = new IntersectionObserver(this.onTrigger.bind(this), { threshold: 0 });
          this.triggerObserver.observe(this.mainButton);
        }

        if (this.footer) {
          this.footerObserver = new IntersectionObserver(this.onFooter.bind(this), {
            rootMargin: '0px 0px -120px 0px',
          });
          this.footerObserver.observe(this.footer);
        }

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== this.sectionId) return;
          this.updateVariant(event.data.variant, event.data.html);
        });
      }

      disconnectedCallback() {
        this.triggerObserver?.disconnect();
        this.footerObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      onTrigger(entries) {
        const entry = entries[0];
        this.pastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.render();
      }

      onFooter(entries) {
        this.nearFooter = entries[0].isIntersecting;
        this.render();
      }

      render() {
        this.classList.toggle('is-visible', this.pastTrigger && !this.nearFooter);
      }

      updateVariant(variant, html) {
        if (!variant) return;

        const label = this.querySelector('.sticky-cta__label');
        if (label) {
          const baseTitle = label.dataset.productTitle || '';
          label.textContent =
            variant.title === 'Default Title' ? baseTitle : `${baseTitle} · ${variant.title}`;
        }

        const priceEl = this.querySelector('.sticky-cta__price');
        const sourcePriceRoot = html?.getElementById(`price-${this.sectionId}`)?.querySelector('.price');
        if (priceEl && sourcePriceRoot) {
          const isOnSale = sourcePriceRoot.classList.contains('price--on-sale');
          const text = isOnSale
            ? sourcePriceRoot.querySelector('.price__sale .price-item--sale')?.textContent
            : sourcePriceRoot.querySelector('.price__regular .price-item--regular')?.textContent;
          if (text) priceEl.textContent = text.trim();
        }

        const img = this.querySelector('.sticky-cta__thumb img');
        if (img && variant.featured_image?.src) {
          const url = new URL(variant.featured_image.src, window.location.origin);
          url.searchParams.set('width', '84');
          img.src = url.toString();
        }

        document.dispatchEvent(new CustomEvent('sticky-cta:variant-change', { detail: { variant } }));
      }
    }
  );
}
